import { HashInfo } from '../../types';
import {
    ExeHashText, HashDot, HashItemContent, HashLinesContainer, HashList,
    HashListItemContainer, HashSeparator, HashText, HashVersion, ItemWrapper, ListItem
} from './HashList.styled';

const HashListItem = ({ index, data }: { index: number, data: HashInfo }) => {
    return (
        <HashListItemContainer key={index}>
            <HashVersion $index={index}>V {data.version}</HashVersion>
            <HashLinesContainer>
                {index === 0 && <HashDot />}
                <HashSeparator $index={index} />
            </HashLinesContainer>
            <HashItemContent>
                <HashList $index={index}>
                    <ListItem key={index}>
                        <ItemWrapper>
                            <span>SHA256 hash sum for</span>
                            <HashText>{data.setupFile}</HashText>
                        </ItemWrapper>
                        <ExeHashText>{data.exeHash}</ExeHashText>
                    </ListItem>
                    {(data.msiSetupFile && data.msiHash) && <ListItem key={index}>
                        <ItemWrapper>
                            <span>SHA256 hash sum for</span>
                            <HashText>{data.msiSetupFile}</HashText>
                        </ItemWrapper>
                        <ExeHashText>{data.msiHash}</ExeHashText>
                    </ListItem>}
                </HashList>
            </HashItemContent>
        </HashListItemContainer>
    );
};

export default HashListItem;
